export interface UserModel {
  id: number;
  displayNumber: string;
  phoneNumber: string;
  email: string;
  oldPassword: string;
  password: string;
  isActive: boolean;
  userType: number;
  claims: number[];
}
